import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { useState, useEffect } from "react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Hook to detect outdoor/sunlight conditions
 * Uses AmbientLightSensor API when available
 * Returns true when illuminance > 10000 lux (bright sunlight)
 */
export const useOutdoorMode = () => {
  const [isOutdoor, setIsOutdoor] = useState(false);

  useEffect(() => {
    // Check if AmbientLightSensor is available
    if ('AmbientLightSensor' in window) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sensor = new (window as any).AmbientLightSensor();
        sensor.addEventListener('reading', () => {
          // > 10000 lux = bright sunlight
          setIsOutdoor(sensor.illuminance > 10000);
        });
        sensor.addEventListener('error', () => {
          // Sensor not available or permission denied
          setIsOutdoor(false);
        });
        sensor.start();

        return () => {
          sensor.stop();
        };
      } catch {
        // Sensor not available
        setIsOutdoor(false);
      }
    }
  }, []);

  return isOutdoor;
};
